import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { API } from '@unboared/react';

export function useLanguageManager() {
    const { i18n } = useTranslation();

    useEffect(() => {
        // `<html lang>` est posé par main.tsx en écoutant `languageChanged`.
        API.onLanguageChange((language) => {
            i18n.changeLanguage(language);
        });
    }, []);

    useEffect(() => {
        const language = API.getLanguage();
        i18n.changeLanguage(language);
    }, []);
}
